import { render } from "./GridDrepturiAgenti.vue?vue&type=template&id=2871ca4a&scoped=true&ts=true"
import script from "./GridDrepturiAgenti.vue?vue&type=script&lang=ts"
export * from "./GridDrepturiAgenti.vue?vue&type=script&lang=ts"

import "./GridDrepturiAgenti.vue?vue&type=style&index=0&id=2871ca4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2871ca4a"]])

export default __exports__